import type { ProductsWithTasks, Stage } from './types'

export const CORE_TASKS_DATA_DEFINITION = {
  probate: [
    {
      name: 'sale',
      title: 'Sale',
      tasks: [
        {
          value: 'referral_made',
          label: 'Make referral',
        },
        {
          value: 'case_booked',
          label: 'Book case',
        },
      ],
    },
    {
      name: 'onboarding',
      title: 'Onboarding',
      tasks: [
        {
          value: 'signed_terms_added_to_backstage',
          label: 'Check that signed T&Cs are on Backstage',
        },
        {
          value: 'kyc_and_aml_checks_completed',
          label: 'Check that KYC and AML report is clear',
        },
        { value: 'welcome_call_completed', label: 'Make welcome call' },
        { value: 'welcome_pack_sent', label: 'Send welcome pack' },
        {
          value: 'received_online_questionaire',
          label: 'Received online Estate Questionnaire',
        },
        {
          value: 'deceased_details_confirmed_in_exizent',
          label: 'Confirm deceased details in Exizent',
        },
        {
          value: 'personal_representative_details_confirmed_in_exizent',
          label: 'Confirm personal representative details in Exizent',
        },
        {
          value: 'estate_solvency_confirmed',
          label: 'Confirm estate solvency',
        },
        {
          value: 'death_certificate_added_to_backstage',
          label:
            'Death certificate received, scanned, stored and added to Backstage and Exizent',
        },
        {
          value: 'paperwork_for_non_acting_executors_added_to_backstage',
          label:
            'Powers reserved completed and saved to Backstage for any non-acting Executors',
        },
        {
          value: 'family_documents_uploaded',
          label:
            'Scan and upload applicable certificates to confirm Next of Kin status',
        },
        {
          value: 'property_details_confirmed',
          label: 'Confirm property details',
        },
        {
          value: 'sale_or_transfer_of_properties_instructed',
          label: 'Instruct a sale or transfer of properties',
        },
        {
          value: 'estate_documents_uploaded',
          label: 'Scan and upload estate documents (e.g. bills)',
        },

        {
          value: 'asset_and_liability_holders_contacted',
          label:
            'Contact all asset and liability holders not included in the Death Notification Service, including HM Revenue and Customs and Department for Work and Pensions',
        },
        {
          value: 'asset_and_liability_holders_confirmed',
          label: 'Recieve replies and update Exizent',
        },
      ],
    },
    {
      name: 'grant_application',
      title: 'Grant Application',
      tasks: [
        {
          value: 'schedule_of_assets_and_liabilities_completed',
          label:
            'Run an asset and liability schedule and share with the Client for approval',
        },
        { value: 'tax_liability_confirmed', label: 'Confirm tax liability' },
        {
          value: 'grant_application_completed',
          label: 'Prepare grant application',
        },
        {
          value: 'grant_application_approved',
          label: 'Get grant application approved',
        },
        {
          value: 'grant_application_submitted',
          label: 'Submit grant application',
        },
        {
          value: 'grant_application_acknowledged_by_hmrc',
          label: 'Receive application acknowledgement',
        },
      ],
    },
    {
      name: 'awaiting_grant',
      title: 'Awaiting grant',
      tasks: [
        {
          value: 'confirmation_of_grant_issue_received',
          label: 'Receive confirmation of grant issue',
        },
        {
          value: 'grant_of_probate_received',
          label: 'Receive grant',
        },
        {
          value: 'initial_invoice_raised',
          label: 'Raise invoice in Xero',
        },
        {
          value: 'initial_invoice_sent',
          label: 'Send invoice to client',
        },
      ],
    },
    {
      name: 'estate_administration',
      title: 'Estate Administration',
      tasks: [
        {
          value: 'forms_and_grant_sent_to_asset_and_liability_holders',
          label: 'Submit closure forms with grant',
        },
        {
          value: 'beneficiary_kyc_and_aml_checks_completed',
          label:
            'Arrange KYC and AML checks and insolvency checks for all Beneficiaries',
        },
        {
          value: 'assets_received_from_asset_holders',
          label: 'Receive all assets from asset holders',
        },
        { value: 'all_liabilities_paid', label: 'Pay all expenses' },
      ],
    },
    {
      name: 'distribution',
      title: 'Distribution',
      tasks: [
        {
          value: 'ledger_matches_estate_accounts_confirmed',
          label: 'Confirm Clio ledger matches estate accounts',
        },
        {
          value: 'estate_accounts_approved_by_customer',
          label: 'Get final estate accounts approved internally and by Client',
        },
        {
          value: 'beneficiaries_confirmed_distributions',
          label: 'Notify Beneficiaries of distribution being arranged',
        },
        {
          value: 'final_distributions_made_to_beneficiaries',
          label: 'Arrange Residuary Payments and arrange receipt',
        },
        {
          value: 'thank_you_letter_sent_to_beneficiaries',
          label: 'Issue R185(EI) to Beneficiaries with thank you letter',
        },
      ],
    },
    {
      name: 'close_case',
      title: 'Close case',
      tasks: [
        {
          value: 'initial_invoice_paid_confirmed',
          label: 'Confirm on Xero that the invoice has been paid',
        },
        {
          value: 'ledger_balance_confirmed_zero',
          label: 'Confirm Clio ledger balance is zero',
        },
        {
          value: 'case_closed',
          label: 'Close case',
        },
      ],
    },
  ],
  lpa: [
    {
      name: 'sale',
      title: 'Sale',
      tasks: [
        { value: 'payment_received_in_full', label: 'Take payment' },
        { value: 'fact_find_booked', label: 'Book fact find call' },
      ],
    },
    {
      name: 'fact_find',
      title: 'Fact find',
      tasks: [
        {
          value: 'fact_find_call_completed',
          label: 'Complete fact find call',
        },
        {
          value: 'aircall_link_attached',
          label: 'Link to Aircall recording in Backstage',
        },
      ],
    },
    {
      name: 'prepare_application',
      title: 'Prepare application',
      tasks: [
        {
          value: 'lpa_generated_and_downloaded',
          label: 'Generate and download LPA',
        },
        {
          value: 'lpa_saved_to_customer_folder',
          label: 'Save LPA in customer folder',
        },
        {
          value: 'lpa_emailed_to_customer',
          label: 'Send customer email with LPA to review',
        },
        {
          value: 'confirmed_no_changes_needed',
          label: "Confirm customer doesn't need any changes to LPA",
        },
        {
          value: 'lpa_sent_to_print_house',
          label: 'Send LPA and cover letter to print house to be posted',
        },
        {
          value: 'customer_notified_of_posting',
          label: 'Email customer that LPA has been posted',
        },
      ],
    },
    {
      name: 'close_case',
      title: 'Close case',
      tasks: [
        {
          value: 'registration_reminder_sent',
          label: 'Remind customer to register the LPA with the OPG',
        },
        {
          value: 'nps_requested',
          label: 'Send NPS request',
        },
        {
          value: 'case_closed',
          label: 'Close case',
        },
      ],
    },
  ],
  funeral: [
    {
      name: 'sale',
      title: 'Sale',
      tasks: [
        {
          value: 'take_payment',
          label: 'Payment has been taken',
        },
        {
          value: 'fact_find_completed',
          label: 'Fact find has been completed',
        },
        {
          value: 'form_1_sent_to_customer',
          label: 'Form 1 has been sent to the customer',
        },
      ],
    },
    {
      name: 'urgent_collection',
      title: 'Urgent collection',
      tasks: [
        {
          value: 'urgent_complete_provider_form',
          label:
            'Provisionally complete provider form and email it to provider',
        },
        {
          value: 'organise_collection',
          label: 'Organise urgent collection with provider',
        },
      ],
    },
    {
      name: 'prepare_paperwork',
      title: 'Prepare paperwork',
      tasks: [
        { value: 'make_welcome_call', label: 'Make welcome call' },
        {
          value: 'ask_memorialisation_preferences',
          label: 'Ask memorialisation preferences',
        },
        {
          value: 'form_1_received_and_checked',
          label: 'Receive and check signed Form 1',
        },
        { value: 'upload_form_1', label: 'Upload Form 1' },
        {
          value: 'send_form_1_confirmation_email',
          label: 'Send Welcome Email',
        },
        {
          value: 'green_/_form_6_received_and_checked',
          label: 'Receive and Check Green Form OR Form 6',
        },
        {
          value: 'upload_green_/_form_6',
          label: 'Upload Green Form OR Form 6',
        },
        {
          value: 'crem_4_received',
          label: 'Receive and check Crem 4',
        },
        {
          value: 'form_4_received_and_checked',
          label: 'Form 4 received and checked',
        },
        {
          value: 'form_4_uploaded',
          label: 'Form 4 uploaded',
        },
        { value: 'complete_provider_form', label: 'Complete provider form' },
        { value: 'send_provider_form', label: 'Upload/Send provider form' },
      ],
    },
    {
      name: 'confirm_collection_date',
      title: 'Confirm collection date',
      tasks: [
        {
          value: 'document_collection_date_in_backstage',
          label: 'Copy and confirm collection date',
        },
        {
          value: 'call_customer_to_confirm_collection',
          label: 'Call customer to confirm collection',
        },
        {
          value: 'send_collection_confirmation_email',
          label: 'Send collection confirmation email',
        },
      ],
    },
    {
      name: 'confirm_cremation_date',
      title: 'Confirm cremation date',
      tasks: [
        {
          value: 'document_cremation_date_in_backstage',
          label: 'Copy and confirm cremation date',
        },
        {
          value: 'call_customer_to_confirm_cremation',
          label: 'Call customer to confirm cremation date',
        },
        {
          value: 'send_cremation_confirmation_email',
          label: 'Send cremation confirmation email',
        },
      ],
    },
    {
      name: 'confirm_service_details',
      title: 'Confirm service details',
      tasks: [
        {
          value: 'book_funeral_with_crematorium',
          label: 'Book funeral date with crematorium',
        },
        { value: 'upload_preliminary_doc', label: 'Upload preliminary doc' },
        {
          value: 'send_funeral_confirmation_email',
          label: 'Send funeral confirmation email',
        },
        {
          value: 'notify_provider_of_any_extras',
          label: 'Confirm funeral date and notify provider of any extras',
        },
        {
          value: 'email_paperwork_to_crematorium',
          label: 'Email preliminary and funeral paperwork to crematorium',
        },
        {
          value: 'send_booking_form_to_provider',
          label: 'Send booking form to provider',
        },
        {
          value: 'make_arrangements_for_music_and_funeral',
          label: 'Make arrangements for music and funeral',
        },
      ],
    },
    {
      name: 'confirm_delivery_date',
      title: 'Confirm delivery date',
      tasks: [
        {
          value: 'document_delivery_date_in_backstage',
          label: 'Copy and confirm delivery date',
        },
        {
          value: 'send_delivery_email',
          label: 'Send delivery date confirmation email',
        },
      ],
    },
    {
      name: 'feedback_and_close_case',
      title: 'Feedback and close case',
      tasks: [
        { value: 'make_feedback_call', label: 'Make feedback call' },
        { value: 'send_delighted_email', label: 'Send NPS email' },
        { value: 'send_cross-sell_email', label: 'Send cross-sell email' },
        {
          value: 'receive_payment_in_full',
          label: 'Receive payment in full',
        },
        { value: 'close_case', label: 'Close case' },
      ],
    },
  ],
  will: [
    {
      name: 'sale',
      title: 'Sale',
      tasks: [
        {
          value: 'book_fact_find_appointment',
          label: 'Book fact find appointment',
        },
      ],
    },
    {
      name: 'pre_appointment_checklist',
      title: 'Pre-appointment checklist',
      tasks: [
        {
          value: 'receive_domicile_questionnaire',
          label: 'Receive domicile questionnaire',
        },
        {
          value: 'receive_conflict_of_interest_form',
          label: 'Receive conflict of interest form (if applicable)',
        },
        {
          value: 'receive_assets_and_liability_grid',
          label: 'Receive assets and liability grid',
        },
      ],
    },
    {
      name: 'fact_find',
      title: 'Fact find',
      tasks: [
        {
          value: 'complete_fact_find_appointment',
          label: 'Complete fact find appointment',
        },
        {
          value: 'log_appointment_details',
          label: 'Log appointment details and customer preferences',
        },
        {
          value: 'send_post_appointment_email',
          label: 'Send post-appointment email',
        },
        {
          value: 'log_will_features',
          label: 'Log will features and add will grade',
        },
        {
          value: 'receive_all_information',
          label:
            'Receive all information (completing this task sets documents due date)',
          automateDueDates: [
            {
              coreTask: 'send_documents_to_customer',
              days: 10,
              daysIfUrgent: 2,
            },
          ],
        },
      ],
    },
    {
      name: 'draft_documents',
      title: 'Draft documents',
      tasks: [
        { value: 'draft_will_documents', label: 'Draft will documents' },
        { value: 'log_drafting_time', label: 'Log drafting time' },
        { value: 'log_reporting_data', label: 'Log reporting data' },
      ],
    },
    {
      name: 'send_documents',
      title: 'Send documents',
      tasks: [
        {
          value: 'send_documents_to_customer',
          label:
            'Send documents to customer (completing this task sets case closed due date)',
          automateDueDates: [
            {
              coreTask: 'close_case',
              days: 10,
              daysIfUrgent: 2,
            },
          ],
        },
      ],
    },
    {
      name: 'close_case',
      title: 'Close case',
      tasks: [
        { value: 'close_case', label: 'Close case' },
        { value: 'send_nps_request', label: 'Send NPS request' },
      ],
    },
  ],
} as const

export const CORE_TASKS_IN_ORDER: Record<ProductsWithTasks, readonly Stage[]> =
  CORE_TASKS_DATA_DEFINITION

export const PRODUCTS_WITH_TASKS = Object.keys(
  CORE_TASKS_DATA_DEFINITION
) as ProductsWithTasks[]

export const TASK_ASSIGNMENT_ROLES = {
  ASSIGNED: 'assigned',
  HELP_REQUESTED: 'help_requested',
}
